export class FetchCountries {
    static readonly type = '[app] fetch countries';
    constructor() { }
}